import React from 'react'
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../../components/auth/useAuth'
import { Link } from 'react-router-dom'

export default function Menu() {
	const { t } = useTranslation()
	const { clientauth, logout } = useAuth()

	return (
		<div className='cabecera d-flex justify-content-center align-items-center px-4 sticky-top'>
			<Navbar id="menu" expand="lg" className='me-auto'>
				<Container>
					<Navbar.Brand href="#home">
						<img
							src="/images/logo-cegam-blanco.png"
							className="d-inline-block align-top justify-center logo"
							alt="Logotipo Cegam"
							width={150}
							id="logo-menu"
						/>
					</Navbar.Brand>
					<Navbar.Toggle aria-controls="basic-navbar-nav" />
					<Navbar.Collapse id="basic-navbar-nav" className='mt-auto'>
						<Nav className="me-auto ps-3">
							{clientauth?.rol === 'Admin' ?
								<>
									<Nav.Link as={Link} to="/admin/dashboard">{t('admin.dashboard.index')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/budgets">{t('admin.dashboard.budgets')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/workorders">{t('admin.dashboard.workOrders')}</Nav.Link>
									<NavDropdown title={t('admin.dashboard.businesses')} id="basic-nav-dropdown">
										<NavDropdown.Item as={Link} to="/admin/providers">{t('admin.dashboard.providers')}</NavDropdown.Item>
										<NavDropdown.Item as={Link} to="/admin/clients">{t('admin.dashboard.clients')}</NavDropdown.Item>
									</NavDropdown>
									{/* <NavDropdown title={t('admin.dashboard.billing')} id="basic-nav-dropdown">
										<NavDropdown.Item as={Link} to="/admin/autobills">{t('admin.dashboard.autobills')}</NavDropdown.Item>
										<NavDropdown.Item as={Link} to="/admin/bills">{t('admin.dashboard.bills')}</NavDropdown.Item>
										<NavDropdown.Item as={Link} to="/admin/proformas">{t('admin.dashboard.proformas')}</NavDropdown.Item>
									</NavDropdown> */}
									<NavDropdown title={t('admin.dashboard.config')} id="basic-nav-dropdown">
										<NavDropdown.Item as={Link} to="/admin/parameters">{t('admin.dashboard.parameters')}</NavDropdown.Item>
										<NavDropdown.Item as={Link} to="/admin/analisystypes">{t('admin.dashboard.analisysTypes')}</NavDropdown.Item>
									</NavDropdown>

									<Nav.Link as={Link} to="/admin/users">{t('admin.dashboard.users')}</Nav.Link>
									<Nav.Link as={Link} to="/admin/operators">{t('admin.dashboard.operators')}</Nav.Link>
									{/* <Nav.Link as={Link} to="/admin/logs">{t('admin.dashboard.logs')}</Nav.Link> */}
								</>
								:
								''
							}
							{clientauth?.rol === 'Laboratory' ?
								<>
									<Nav.Link as={Link} to="/laboratory/dashboard">{t('admin.dashboard.index')}</Nav.Link>
									<Nav.Link as={Link} to="/laboratory/workorders">{t('admin.dashboard.workOrders')}</Nav.Link>
									<Nav.Link as={Link} to="/laboratory/parametersInput">{t('admin.parameters.parametersInput')}</Nav.Link>
								</>
								:
								''
							}
							<Nav.Link as={Link} to="/" onClick={logout}>{t('signin.logout')}</Nav.Link>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</div>

	)
}